import React from 'react';
import { Box, Typography } from '@mui/material';
import theme from '../../../constants/theme';
import { Chip } from '../../chip';
import { Selected } from '../props';
import { FilterChips } from './chips';
import ArrowIcon from '../../../assets/img/arrowFilter.svg';
import GreenArrowIcon from '../../../assets/img/greenArrow.svg';

type Props = {
  open?: boolean;
  name?: string;
  arr?: Array<Selected>;
  isMobile?: boolean;
  removeChips: (removeAll: boolean, label?: string) => void;
};

export const TitleAndChips = ({
  open,
  name,
  arr,
  removeChips,
  isMobile,
}: Props) => {
  return (
    <React.Fragment>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        <Typography
          variant="subtitle1"
          fontWeight={600}
          color={
            open ? theme.palette.primary.main : theme.palette.text.secondary
          }
        >
          {name}
        </Typography>

        {!isMobile && (
          <img src={open ? GreenArrowIcon : ArrowIcon} alt={name} />
        )}
      </Box>

      {arr?.length ? (
        <Box
          mt={2}
          display="flex"
          alignItems="flex-start"
          flexWrap="wrap"
          flexDirection="column"
        >
          <FilterChips
            arr={arr}
            removeChips={(label) => removeChips(false, label)}
          />
          <Chip
            label="Zurücksetzen"
            onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
              e.stopPropagation();
              removeChips(true);
            }}
            sx={{
              background: theme.palette.transparent.main,
              color: theme.palette.primary.main,
              svg: {
                display: 'none !important',
              },
              '&:hover': {
                background: theme.palette.transparent.main,
              },
            }}
          />
        </Box>
      ) : null}
    </React.Fragment>
  );
};
